import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BillingPopupInvoiceDowngradeComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	@action
	contactSupport(): void {
		this.currentUserService.chatWithSupport();
	}
	<template>
		<div class="content">
			<h3>Your subscription is set to be paid via manual invoices</h3>
			<p>
				You are unable to shorten the billing cycle. Please
				<a
					class="link link--secondary link--underline"
					{{on "click" this.contactSupport}}
				>contact our support team
				</a>
				for more information.
			</p>
			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent @text="Close" @onTrigger={{this.close}} />
				</div>
			</div>
		</div>
	</template>
}
